<template>
  <div id="rule" class="page">
    <div v-html="contents"></div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'rule',
    data() {
      return {
        contents: ''
      }
    },
    created () {
      axios.get('/pages/rule.json').then(response => {
        this.contents = response.data.pages[0].body;
      })
    },
  }
</script>

<style scoped>
  .page{
    padding: 10px 10px 60px 10px;
  }
</style>
